import { defineMessages } from "react-intl";

export const onfidoMessages = defineMessages({
  onfidoFatalError: { id: "onfido.process.fatal_error" },
  onfidoUserError: { id: "onfido.process.user_error" },
});
